// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__9dlX0","header":"PatientQuestionnaire_header__3dbKd","info":"PatientQuestionnaire_info__3Q9xP"};